import { Dispatch, SetStateAction } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { enqueueSnackbar } from 'notistack';

import { useShowError } from 'hooks/useShowError';
import { useFormMutation } from 'mutations/useFormMutation';
import { DreSubgrupo } from 'pages/financeiro/dre/configuracao/types';

export function useMutateSubgrupo({ setOpen }: { setOpen: Dispatch<SetStateAction<boolean>> }) {
    const { mutate, isLoading } = useFormMutation<AxiosResponse<DreSubgrupo>>();
    const { showError } = useShowError();
    const queryClient = useQueryClient();

    /**
     * Salva o subgrupo
     */
    const onSubmitForm = (formData: DreSubgrupo) => {
        const isCreating = !formData.idDreMercadologicaGrupoExibicao;

        mutate(
            {
                formData,
                url: '/dre/dremercadologicagrupoexibicao',
                idField: 'idDreMercadologicaGrupoExibicao',
                preventSnack: true,
                preventRedirect: true,
            },
            {
                onSuccess: () => {
                    queryClient.invalidateQueries(['querySubgrupos']);

                    enqueueSnackbar(`Subgrupo ${isCreating ? 'criado' : 'atualizado'} com sucesso`, { variant: 'success' });

                    setOpen(false);
                },
                onError: (error) => showError(error, `Falha ao ${isCreating ? 'criar' : 'atualizar'} subgrupo`),
            },
        );
    };

    return { onSubmitForm, isLoading };
}
